import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { EaGridkyService } from '../ea-gridky.service';

@Component({
    selector: 'ea-gridky-subtitle',
    templateUrl: './ea-gridky-subtitle.component.html',
    styleUrls: ['./ea-gridky-subtitle.component.scss'],
    standalone: false
})
export class EaGridkySubtitleComponent implements OnInit {
  _ = _;
  constructor(private gridkyService: EaGridkyService) {}

  ngOnInit() {}

  get product() {
    return this.gridkyService.product || undefined;
  }
}
